module.exports = __webpack_public_path__ + "img/modi-main-top.76fd4202.png";